<template>  
    <div>
      <!-- <button v-on:click="$store.commit('updateSelectedFinition', 'BLK')">Finition 1</button>
        <button v-on:click="runTransform($store.state.buyfast.coords)">Test</button>
        <button v-on:click="$window.alert($store.state.buyfast.selected_size.coords)">show coords</button>
      <button v-on:click="$store.commit('updateSelectedFinition', 'WHT')">Finition 2</button>
      <button v-on:click="$store.commit('updateSelectedFinition', 'ALU')">Finition 3</button>
      <button v-on:click="changeSize({height: 80, width: 120})">80x120</button>
      <button v-on:click="$store.commit('updateWithBackground', !$store.state.buyfast.withBackground)">show background</button>
      <button v-on:click="changeSize({height: 130, width: 195})">130x195</button> -->
      <!-- replacer le 500px vvv -->
      <div class="helper--transform" ref="positionContainer">
       <img v-if="$store.state.buyfast.currentSlide == 1" class="test--preview composition-0" src='/static/img/configurator/base_config_wall.webp' alt=""/>
       <img v-if="$store.state.buyfast.currentSlide == 2" class="test--preview composition-1" :src="`/static/img/configurator/closeup_${$store.state.buyfast.selected_finition}.png`" alt=""/>
       <img v-if="$store.state.buyfast.currentSlide == 2" class="test--preview composition-1" :src="$store.state.buyfast.currentFrame.finition_img" alt=""/>
       <img v-if="$store.state.buyfast.currentSlide == 1" class="test--preview composition-1" :src="`/static/img/configurator/frames/wall/${$store.state.buyfast.selected_finition}_${$store.state.buyfast.selected_size.width}x${$store.state.buyfast.selected_size.height}.webp`" alt=""/>
       <img v-if="$store.state.buyfast.currentSlide == 1" :src="$store.state.buyfast.currentFrame.base_img" class="test--place-holder" :style="[{
         
         transformOrigin: '0px 0px',
         transform: $store.state.buyfast.transform,
        },
        $store.state.buyfast.selected_size.width > $store.state.buyfast.selected_size.height
        ?{
          marginLeft: `calc(50% - ${(($store.state.buyfast.selected_size.width/$store.state.buyfast.selected_size.width)*300)/2}px)`,
          height: (($store.state.buyfast.selected_size.height/$store.state.buyfast.selected_size.width)*300)+'px',
          width: (($store.state.buyfast.selected_size.width/$store.state.buyfast.selected_size.width)*300)+'px',
          
        }
        :{
         marginLeft: `calc(50% - ${(($store.state.buyfast.selected_size.width/$store.state.buyfast.selected_size.height)*300)/2}px)`,
         height: (($store.state.buyfast.selected_size.height/$store.state.buyfast.selected_size.height)*300)+'px',
         width: (($store.state.buyfast.selected_size.width/$store.state.buyfast.selected_size.height)*300)+'px',

       }]"/>
      <div class="navigation-wrapper">
        <!--<div class="dots">
          <div class="dot active"></div>
          <div class="dot"></div>
        </div>-->
        <div class="arrow arrow-left" v-on:click="toggleSlide()">
          <img src="/static/img/icons/arrow-left.svg" alt="{% trans 'Aller à l'illustration précédente' %}">
        </div>
        <div class="arrow arrow-right" v-on:click="toggleSlide()">
          <img src="/static/img/icons/arrow-right.svg" alt="{% trans 'Aller à l'illustration suivante' %}">
        </div>
      </div>
     </div>
    </div>
   </template>
   
   <script>
   import '../../styles/global.scss'
   
   export default {
     name: 'Preview',
     components: {  
     },
     data(){return {
       // $store.state.buyfast.coords.coords: [[-0.1988, -0.1897], [0.1725, -0.2513], [0.1725, 0.0454], [-0.1988, 0.0476]],
     }},
     beforeCreate(){
       
     },
     mounted(){
       window.addEventListener('resize', this.onResize);
       this.runTransform(this.$store.state.buyfast.selected_size.coords);
     },
     computed: {
     },
     methods: {
      toggleSlide: function(){
        if(this.$store.state.buyfast.currentSlide == 1){
          this.$store.commit('updateCurrentSlide', 2)
        }
        else{
          this.$store.commit('updateCurrentSlide', 1)
        }
      },
       changeSize: function(level){
        //  this.$store.dispatch('selectSize', this.$store.state.buyfast.currentFrame.available_sizes[level]);
         this.$store.dispatch('selectConfort', level);
         this.runTransform(this.$store.state.buyfast.selected_size.coords);
         this.$store.commit('updateCurrentSlide', 1);

       },
       onResize: function(){
         this.runTransform(this.$store.state.buyfast.selected_size.coords);
       },
       getTargetPos: function(targetRelPos){
         const el = document.getElementsByClassName('helper--transform')[0];
           const targetPos = [
             [(el.clientWidth/2) + (targetRelPos[0][0]*el.clientWidth), (el.clientHeight/2) + targetRelPos[0][1]*el.clientWidth],
             [(el.clientWidth/2) + (targetRelPos[1][0]*el.clientWidth), (el.clientHeight/2) + targetRelPos[1][1]*el.clientWidth],
             [(el.clientWidth/2) + (targetRelPos[2][0]*el.clientWidth), (el.clientHeight/2) + targetRelPos[2][1]*el.clientWidth],
             [(el.clientWidth/2) + (targetRelPos[3][0]*el.clientWidth), (el.clientHeight/2) + targetRelPos[3][1]*el.clientWidth],
           ]
           return targetPos;
       },
       getOriginalPos: function(){
         console.log('matrix raz'); //Changer methode de calcul de offset
         const elHeight = this.$store.state.buyfast.selected_size.height > this.$store.state.buyfast.selected_size.width ? 0.6*500 : 0.60*(this.$store.state.buyfast.selected_size.height/this.$store.state.buyfast.selected_size.width)*500;
         const elWidth = this.$store.state.buyfast.selected_size.width > this.$store.state.buyfast.selected_size.height ? 0.6*500 : 0.60*(this.$store.state.buyfast.selected_size.width/this.$store.state.buyfast.selected_size.height)*500;
         const offLeft = (this.$refs.positionContainer.clientWidth - elWidth)/2;
         const offTop = (this.$refs.positionContainer.clientHeight - elHeight)/2;
         
         const originalPos = [
           [offLeft, offTop],
           [offLeft + elWidth, offTop],
           [offLeft + elWidth, offTop+elHeight],
           [offLeft, offTop+elHeight],
         ]
           return originalPos;
       },
       getFrom: function(originalPos){
           var k, len, results;
            results = [];
           for (k = 0, len = originalPos.length; k < len; k++) {
             let p = originalPos[k];
             results.push({
               x: p[0] - originalPos[0][0],
               y: p[1] - originalPos[0][1]
             });
           }
           return results;
       },
       getTo: function(targetPos, originalPos){
           var k, len, results;
           results = [];
           for (k = 0, len = targetPos.length; k < len; k++) {
             let p = targetPos[k];
             results.push({
               x: p[0] - originalPos[0][0],
               y: p[1] - originalPos[0][1]
             });
           }
           return results;
       },
       getTrans: function(from, to) {
           var A, H, b, h, i, k, k_i, l, lhs, m, ref, rhs;
           console.assert((from.length === (ref = to.length) && ref === 4));
           A = []; // 8x8
           for (i = k = 0; k < 4; i = ++k) {
             A.push([from[i].x, from[i].y, 1, 0, 0, 0, -from[i].x * to[i].x, -from[i].y * to[i].x]);
             A.push([0, 0, 0, from[i].x, from[i].y, 1, -from[i].x * to[i].y, -from[i].y * to[i].y]);
           }
           b = []; // 8x1
           for (i = l = 0; l < 4; i = ++l) {
             b.push(to[i].x);
             b.push(to[i].y);
           }
           // Solve A * h = b for h
           h = window.numeric.solve(A, b);
           H = [[h[0], h[1], 0, h[2]], [h[3], h[4], 0, h[5]], [0, 0, 1, 0], [h[6], h[7], 0, 1]];
       // Sanity check that H actually maps `from` to `to`
           for (i = m = 0; m < 4; i = ++m) {
             lhs = window.numeric.dot(H, [from[i].x, from[i].y, 0, 1]);
             k_i = lhs[3];
             rhs = window.numeric.dot(k_i, [to[i].x, to[i].y, 0, 1]);
             console.assert(window.numeric.norm2(window.numeric.sub(lhs, rhs)) < 1e-9, "Not equal:", lhs, rhs);
           }
           return H;
         },
         applyTrans: function(H){
           this.$store.commit('updateTransform', `matrix3d(${((function() {
             var k, results;
             results = [];
             for (let i = k = 0; k < 4; i = ++k) {
               results.push((function() {
                 var l, results1;
                 results1 = [];
                 for (let j = l = 0; l < 4; j = ++l) {
                   results1.push(H[j][i].toFixed(20));
                 }
                 return results1;
               })());
             }
             return results;
           })()).join(',')})`);
   
   
         },
         runTransform: function(targetRelPos){
           if (!targetRelPos){
             console.log('pas de coordonées pour cette dimension');
             return;
           }
             const originalPos = this.getOriginalPos();
             const targetPos = this.getTargetPos(targetRelPos);
             const from = this.getFrom(originalPos);
             const to = this.getTo(targetPos, originalPos);
             const H = this.getTrans(from, to);
             this.applyTrans(H);
           },
     },
   
     beforeUnmount(){
       window.removeEventListener('resize', this.onResize);
     }
   }
   </script>
   
<style lang="scss" scoped>

.test--preview{
  // min-width: 500px;
  // min-height: 500px;
}
.helper--transform{
  position: relative;
  aspect-ratio: 1533/1312; //peut être changé en nimporte quelle hauteur a priori
  display: flex;
  align-items: center;
  //  transform: scale(1.3);
  // pointer-events: none;
  // toujours le pb de connaitre le ratio

  // height: 400px;
  overflow: hidden;
}
.composition-0{
  position: absolute;
}
.composition-1{
  position: absolute;
  pointer-events: none;
  width: 100%;
}
.test--place-holder{
  width: 40%;
  top: 0;
  bottom: 0;
  // background-color: red;
  position: relative;
  
}

//navigation

.navigation-wrapper{
position: absolute;
width: 100%;
height: 100%;
}

.arrow{
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  cursor: pointer;
}

.arrow::before{
  content: '';
  width: 150%;
  height: 150%;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background-color: white;
  z-index: 1;
}

.arrow > img{
  position: absolute;
  z-index: 2;
}
.arrow-left{
left: 20px;
}

.arrow-right{
right: 20px;
}

// .dots{
// position: absolute;
// bottom: 20px;
// margin: auto;
// display: flex;
// left: 50%;
// transform: translateX(-50%);
// }

// .dot {
//     border-radius: 50%;
//     border: 2px solid transparent;
//     margin: 0 5px;
//     padding: 10px;
//     cursor: pointer;
//     position: relative;
  
    
// }

// .dot::after{
//     content:'';
//     position: absolute;
//     width: 12px;
//     height: 12px;
//     background-color: black;
//     color: black;
//     border-radius: 50%;
//     transform: translate(-50%, -50%);
// }

// .dot:focus {
// outline: none;
// }

// .dot.active {
// border: 2px solid black;
// }

</style>
<style lang="scss">


</style>
   
   
   